import React, { useContext } from 'react';
import LazyImage from '../../helpers/LazyImage';
import { MemorialHeroProps } from './MemorialHero.types';
import * as Styles from './MemorialHero.styles';
import { ThemeContext } from 'styled-components';

const MemorialHero: React.FC<MemorialHeroProps> = ({
  src,
  placeholder,
  alt,
  children,
  councilServices,
  searchSuggestions = []
}) => {
  const themeContext = useContext(ThemeContext);

  return (
    <>
      <Styles.Wrapper aria-label="Memorial Hero">
        <Styles.HiddenH1>{themeContext.full_name} Council</Styles.HiddenH1>
        <Styles.Container>
          <Styles.Left>
            {children}
            {councilServices}
          </Styles.Left>
          <Styles.Right>
            <LazyImage
              src={src}
              placeholder={placeholder}
              visibilitySensorProps={{
                partialVisibility: true,
              }}
            >
              {(src) => <Styles.Image $image={src} title={alt} />}
            </LazyImage>
          </Styles.Right>
        </Styles.Container>
      </Styles.Wrapper>
    </>
  );
};

export default MemorialHero;